module.exports = __webpack_public_path__ + "static/media/ic-vision.b8b1afde.svg";